// Export the tour steps for CompanyDetails form fields
export const companyDetailsGuideSteps = [
  {
    element: "#CD-company-name",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Company Name</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Enter your company's official name as it appears on legal documents and business registrations.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <p class="text-xs text-brand-800 font-medium">This name will be displayed to affiliates and customers on your brand profile.</p>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#CD-company-username",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Company Username</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Choose a unique username for your company profile. This will be used in your brand's URL.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <p class="text-xs text-brand-800 font-medium">Example: If you choose "mybrand", your profile URL will be /store/mybrand</p>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#CD-company-niches",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Company Niches</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Select up to 3 industries that best describe your company. This helps affiliates find and understand your brand.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• Search and select from available niches</li>
              <li>• Choose industries relevant to your products</li>
              <li>• Helps with affiliate matching</li>
            </ul>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#CD-company-profile-photo",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Company Visuals</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Upload your company logo and banner image to create a professional brand profile.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• Logo: Square image displayed on your profile</li>
              <li>• Banner: Wide image at the top of your profile</li>
              <li>• Supported formats: SVG, PNG, JPG, GIF</li>
              <li>• Max size: 800x400px</li>
            </ul>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#CD-company-description",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Company Description</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Write a compelling description about your company, products, and what makes your brand unique.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• Tell your brand story</li>
              <li>• Highlight your unique value proposition</li>
              <li>• Include key product categories</li>
              <li>• Maximum 275 characters</li>
            </ul>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#CD-company-social-links",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 4V2a1 1 0 011-1h8a1 1 0 011 1v2m-9 0h10m-10 0a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2M9 4a2 2 0 012-2h2a2 2 0 012 2"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Social Media Links</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Add your social media profiles to help affiliates and customers connect with your brand.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• Instagram: Enter your username</li>
              <li>• TikTok: Enter your username</li>
              <li>• YouTube: Enter your channel name</li>
              <li>• Facebook: Enter your page name</li>
              <li>• Discord: Enter full community URL (https://discord.gg/...)</li>
            </ul>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#CD-save-company-profile",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Save Company Profile</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Save your company information to complete your brand profile setup. You can always edit these details later.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <p class="text-xs text-brand-800 font-medium">Your profile will be visible to affiliates and customers once saved!</p>
          </div>
        </div>`,
      side: "top" as const,
      align: "center" as const,
    },
  },
];
